import { render, staticRenderFns } from "./sendMember.vue?vue&type=template&id=11af63f6&scoped=true&"
import script from "./sendMember.vue?vue&type=script&lang=js&"
export * from "./sendMember.vue?vue&type=script&lang=js&"
import style0 from "./sendMember.vue?vue&type=style&index=0&id=11af63f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11af63f6",
  null
  
)

export default component.exports